export const setLanguage = (language: string) => ({	type: 'SET_LANGUAGE', payload: language });
export const setConfig = (config: any) => ({ type: 'SET_CONFIG', payload: config });
export const setLogin = (data: boolean) => ({ type: 'SET_LOGIN', payload: data });
